import { useLayoutEffect } from "react";

/**
 * Belt-and-suspenders dedup: any leftover <title> or <meta name="robots">
 * that we shipped as a static fallback in index.html carries the
 * `data-static-seo` marker. Remove those before paint so react-helmet-async
 * is the sole source of live SEO tags.
 *
 * IMPORTANT: this is a whitelist — we only remove nodes WE marked. Do NOT
 * remove Helmet-managed nodes; that corrupts React's virtual DOM reconciler
 * and has previously crashed hydration.
 */
export default function useStripStaticSeoTags() {
  useLayoutEffect(() => {
    if (typeof document === "undefined") return;
    document
      .querySelectorAll(
        "head > title[data-static-seo], head > meta[name='robots'][data-static-seo]"
      )
      .forEach((el) => el.parentNode.removeChild(el));
  });
}
